import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext'
import styled from 'styled-components'

export default function LessonHeader({ unit, lesson }) {
  const { appState } = useContext(AppContext)
  return (
    <LessonHeaderWrapper className="lesson-header">
      <div className="lesson-info">
        <h5 className="pre-title">{appState.course.title} | {unit.unit_name}</h5>
        <h4>{lesson.title}</h4>
        {lesson.tags && lesson.tags.length > 0 && (
          <div className="tag-wrapper">
            <div className="tag-label">Tags:</div>
            <ul className="lesson-tags">
              {lesson.tags.map((tag) => (
                <li key={tag.slug} className="tag">{tag.name}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="lesson-downloads">
        <h5 className="downloads-header">
          <i className="fas fa-download"></i>
          <span>Downloads</span>
        </h5>
        <ul className="downloads">
          {lesson.files && lesson.files.length > 0 ? (
            lesson.files.map((file) => (
              <li key={file.file} className="download">
                <a href={file.file} className="download-link">{file.file_name}</a>
              </li>
            ))
          ) : (
            <div className="no-downloads">No downloads for this lesson.</div>
          )}
        </ul>
      </div>
    </LessonHeaderWrapper>
  )
}

const LessonHeaderWrapper = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
`